export default __webpack_public_path__ + "locales/lv/Common.json?hash=45580f0b74b7b79470623a494f295978";